// The full-page notices that take the place of the whole site: GaintPlay closed in the visitor's
// country (CountryGate) and a blocked account (AccountGate). Same frame for both: the coin, a large
// title, what it means, and at the bottom the one thing still open, writing to support.
import { useEffect, type ReactNode } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import { hideLaunchSplash } from '../lib/splash';
import { CoinMascot } from './Coin';

export const SUPPORT_EMAIL = 'support@gaintplay.com';

/** Sign out from a notice: the session goes, and the site starts again from the top. */
export function useLeave() {
  const qc = useQueryClient();
  return async () => {
    await api('/auth/logout', { body: {} }).catch(() => {});
    qc.clear();
    window.location.assign('/');
  };
}

export function GateScreen({
  id,
  docTitle,
  eyebrow,
  title,
  children,
  actions,
}: {
  /** The title's element id (the page is labelled by it). */
  id: string;
  /** The browser tab's title. */
  docTitle: string;
  eyebrow?: ReactNode;
  title: string;
  children: ReactNode;
  actions: ReactNode;
}) {
  useEffect(() => {
    document.title = docTitle;
    hideLaunchSplash();
  }, [docTitle]);
  return (
    <main aria-labelledby={id} className="flex min-h-dvh flex-col bg-canvas px-6 pb-safe pt-safe">
      <div className="mx-auto flex w-full max-w-[420px] flex-1 flex-col">
        <div className="flex flex-1 flex-col justify-center pb-8 pt-12">
          <CoinMascot size={104} rotate={-12} className="-ml-1" />
          {eyebrow && <p className="eyebrow mt-8 flex items-center gap-1.5">{eyebrow}</p>}
          <h1 id={id} className={`large-title text-ink ${eyebrow ? 'mt-2' : 'mt-8'}`}>
            {title}
          </h1>
          {children}
        </div>
        <div className="pb-6">{actions}</div>
      </div>
    </main>
  );
}
